export const state = () => ({
    entitySelectorItems: [],
    selectedItem: null,
    entitySelectorConfiguration: { value: '', text: '', name: '' },
    details: ''
})

const getters = {
    getEntitySelectorItems: (state) => {
        return state.entitySelectorItems
    },
    getSelectedItem: (state) => {
        return state.selectedItem
    },
    getEntitySelectorConfiguration: (state) => {
        return state.entitySelectorConfiguration
    },
    getDetails: (state) => {
        return state.details
    }
}

const actions = {
    setEntitySelectorItems({ commit }, entitySelectorItems) {
        commit('setEntitySelectorItems', entitySelectorItems)
    },
    setSelectedItem({ commit }, selectedItem) {
        commit('setSelectedItem', selectedItem)
    },
    setEntitySelectorConfiguration({ commit }, entitySelectorConfiguration) {
        commit('setEntitySelectorConfiguration', entitySelectorConfiguration)
    },
    setDetails({ commit }, details) {
        commit('setDetails', details)
    },
    reset ({ commit }) {
        commit('setEntitySelectorItems', [])
        commit('setSelectedItem', null)
        commit('setEntitySelectorConfiguration', { value: '', text: '', name: '' })
        commit('setDetails', '')
    }
}

const mutations = {
    setEntitySelectorItems (state, entitySelectorItems) {
        state.entitySelectorItems = entitySelectorItems
    },
    setSelectedItem (state, selectedItem) {
        state.selectedItem = selectedItem
    },
    setEntitySelectorConfiguration (state, entitySelectorConfiguration) {
        state.entitySelectorConfiguration = entitySelectorConfiguration
    },
    setDetails (state, details) {
        state.details = details
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
